import { WarehouseMap } from "../models/warehouse.map";
import BaseService from "./_base.service";

const endpoint = "maps";

const WarehousesMapsService = {
  ...BaseService<WarehouseMap>({ endpoint }),
};

export default WarehousesMapsService;
